import React,{useEffect,useState,useRef, use} from 'react';
import { useParams,useNavigate  } from "react-router";
import Navbar from './Navbar';
import Footer from './Footer';
import { useTranslation } from 'react-i18next';
import { AvatarCreator } from "@readyplayerme/react-avatar-creator";
import ChatBot from "react-chatbotify";
import "react-chatbot-kit/build/main.css";
import { Avatar } from "@readyplayerme/visage";
import { Sparkles } from "@react-three/drei";
import axios from "axios";
import {SetUserAvatar,GetUserAvatar} from '../../services/api';

const AvatarChatbot = (props)=>{
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const voiceLang = i18n.language === 'ar' ? "ar-SA" : i18n.language === "en" ? "en-US" : "fr-FR";
    const {id} = useParams();
    const navigate = useNavigate();
    const [showOverlay, setShowOverlay] = useState(false);
    const avatarName = localStorage.getItem("avatar_name");
    const [avatar,setAvatar] = useState(null);
    const [avatarUrl, setAvatarUrl] = useState(null);
    const user_public_id = localStorage.getItem("user_public_id");
    const message = i18n.language === 'ar' ? ` كيف يمكنني مساعدتك اليوم ! ${avatarName} مرحبا انا ` : i18n.language === "en" ? `Hello I'm ${avatarName} ! How can I assist you today` : `Bonjour, je suis ${avatarName} ! Comment puis-je vous aider aujourd’hui ?`;
    const [gender,setGender] = useState('');
    const [showOverlayBackground,setShowOverlayBackground] = useState(false);
    const [avatarJson,setAvatarJson] = useState();
    const [loadingImg, setLoadingImg] = useState(true);
    const aiDemo = props.hostname === "aidemo"

    // const [overlayButtonInitSteps,setOverlayButtonInitSteps] = useState(localStorage.getItem("nextbuttonStep")?localStorage.getItem("nextbuttonStep"):0);
    // const [overlayInitStep1,setOverlayInitStep1] = useState(false);

    useEffect(()=>{
      if(user_public_id){

            if(aiDemo && id){
                setAvatar(null);
            } else if(aiDemo){
                setAvatar(localStorage.getItem("avatar_id"))
            }
            
            GetUserAvatar(user_public_id)
            .then((response)=>{
        
                if(response.data.status == "success"){
                  setAvatar(response.data.avatar_id);
                  setAvatarUrl(`https://models.readyplayer.me/${response.data.avatar_id}.png`)
                } 
                if(id){
                    setAvatar(null);
                }
                        
            }).catch((error)=>{console.error('Error:', error);})

        }
    },[user_public_id])


    useEffect(() => {
        const getGender = async () => {
            try {
                if (avatar){
                    const response = await axios.get(`https://models.readyplayer.me/${avatar}.json`);
                    const gender =   response.data.outfitGender === "feminine" ? "female" : "male";
                    setGender(gender);
                }
        
            } catch (error) {
              console.error("Error fetching avatar gender:", error);
            }
          };

        getGender()
    }, []);

    const getVoiceForLanguageAndGender = (languageCode, genderPreference) => {
        if ('speechSynthesis' in window) {
          const voicesForLang = speechSynthesis.getVoices().filter(voice =>
            voice.lang.startsWith(languageCode)
          );
      
          const preferredVoices = voicesForLang.filter(voice => {
            const voiceNameLower = voice.name.toLowerCase();
            return (genderPreference === 'male' && (voiceNameLower.includes('male') || voiceNameLower.includes('man'))) ||
                   (genderPreference === 'female' && (voiceNameLower.includes('female') || voiceNameLower.includes('woman')));
          });
      
          if (preferredVoices.length > 0) {
            return preferredVoices[0].name; 
          }
      
          return voicesForLang[0]?.name || '';
        } else {
          console.log("SpeechSynthesis is not supported in this browser.");
          return '';
        }
    }

    const voiceName = getVoiceForLanguageAndGender(voiceLang,gender);


    const fetchData = async (params) =>{
        try {
                const response = await axios.post("https://wellbe-api-298047552813.us-central1.run.app/chat_with_ai", {
                response: params.userInput,
                role: localStorage.getItem("role"),
          });
                return response.data.response
            } catch (error) {
                return "Oh no I don't know what to say!";
            }
      }

    const flow={
		start: {
			message: message,
			path: "loop"
		},
		loop: {
			message: async (params) => {
				const result = await fetchData(params);
				return result;
			},
			path: "loop",
		}
	}

    const style = { 
    };

    const settings = {
        isOpen: true,
        general: {
        primaryColor: '#f87e00',
        secondaryColor: '#fab606',
        fontFamily: 'Arial, sans-serif',
        embedded: true
        },
        header: {
        title: avatarName,
        showAvatar: true,
        avatar: avatarUrl,
        },
        notification: {
        disabled: true,
        defaultToggledOn: false,
        },
        audio: {
        disabled: voiceName == '' ? true : false,
        defaultToggledOn: false,
        language: voiceLang,
        voiceNames: voiceName,
        rate: 1,
        volume: 1,
        },
        voice: {
        disabled: false,
        defaultToggledOn: false,
        language: voiceLang,
        timeoutPeriod: 10000,
        autoSendDisabled: true,
        autoSendPeriod: 0,
        sendAsAudio: false,
        },
        chatHistory: {
        storageKey:`${user_public_id ? user_public_id : "concept_settings"}`,
        },
        botBubble: {simStream: true},
        fileAttachment: {
        disabled: false,
        iconDisabled:'',
        },
        footer: {
        text: (
            <div style={{cursor: "pointer", display: "flex", flexDirection: "row", alignItems: "center", columnGap: 3}} >
            </div>
        ),
        },
        device: {
        desktopEnabled: true,
        mobileEnabled: true,
        applyMobileOptimizations: true,
        }
    };
   
    const avatarConfig = {
        clearCache: id ? false : true,
        bodyType: 'fullbody',  
        quickStart: true,
        language: 'en',
        disableSettings: true,
        ...(id ? {avatarId: id } : {})
    };

    // for audio in chatbot
    // useEffect(() => {
    //     let observer;
    //     const checkAndAttach = () => {
    //       const el = document.querySelector('[aria-label="toggle audio"]');
    //       if (!el) return;
      
    //       const handleClick = () => {
           
    //           const icon = el.querySelector("svg");
    //           const isMuted = icon?.style?.fill === "rgb(232, 234, 237)";
      
    //           if (isMuted && window.speechSynthesis.speaking) {
    //             window.speechSynthesis.cancel();
    //             console.log("🔇 Speech canceled immediately on mute.");
    //           }
    //       };
      
    //       el.addEventListener("click", handleClick);
      
    //       return () => {
    //         el.removeEventListener("click", handleClick);
    //         observer?.disconnect();
    //       };
    //     };
      
    //     observer = new MutationObserver(() => {
    //       const el = document.querySelector('[aria-label="toggle audio"]');
    //       if (el) {
    //         checkAndAttach();
    //       }
    //     });
      
    //     observer.observe(document.body, {
    //       childList: true,
    //       subtree: true,
    //     });
      
    //     return () => observer.disconnect();
    // }, []);

    // for overlay next button and settings
    useEffect(() => {
        const handleMessage = (event) => {
          if (event.origin === "https://wellbe.readyplayer.me") {
            console.log("received data",event.data);
            let data = event.data;
            if (typeof data === "string") {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    // It's a string, but not JSON — just ignore it
                    return;
                }
            }

            if(data.eventName == "v1.subscription.created"){
                setShowOverlay(true);
            }

          }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);


    const handleAvatarCreated = async (avatarLink) => {
        localStorage.setItem("role",`health coach.Your name ${avatarName}.You have a empathetic, encouraging, and supportive personality and respond with warmth and emotional intelligence`)
        const avatarId = avatarLink.data.avatarId 

        const formData = new FormData();
        formData.append("user_public_id",user_public_id);
        formData.append("avatar_id",avatarId)

        if(aiDemo){
            setAvatar(avatarId);
            localStorage.setItem("avatar_id",avatarId)
        }

        SetUserAvatar(formData)
        .then((response)=>{
            if(response.data.status == "success"){
                setAvatar(avatarId);
            } 
        }).catch((error)=>{console.error('Error:', error);})
        
        if (id) {
            navigate('/chatbot');
        }
    };

    const handleCloseChatBot = ()=>{
        window.location.href = '/';
    }

    const handleExportedAvatar = async(avatarLink) =>{
        const avatarId = avatarLink.data.avatarId;
        setAvatarUrl(`https://models.readyplayer.me/${avatarId}.png`)
        setShowOverlayBackground(true);
        setAvatarJson(avatarLink);
        setShowOverlay(false);
    }

    const handleChat = () => {
        handleAvatarCreated(avatarJson);
    }

    return(
        <div className='bg-ibw pb-5'>
            <Navbar user_id={props.user_id} setUserId={props.setUserId} hostname={props.hostname}/>
                {avatar ? (
                    <div className='container pb-5' style={{direction:"ltr"}}>
                        <div className='row' style={{border:"1px solid #FF5C28",borderRadius:"10px"}}>
                                <div className='col-md-6 px-0 avatar-height-mobile position-relative' >
                                    <div className={`position-absolute start-0 p-2`} style={{ zIndex: 1050 }}>
                                        <button className="btn-close" aria-label="Close" onClick={handleCloseChatBot}></button>
                                    </div>
                                    <Avatar
                                            animationSrc="/assets/models/F_Standing_Idle_Variations_003.fbx"
                                            background={{ color: 'rgb(13, 13, 13)' }}
                                            cameraInitialDistance={3.2}
                                            cameraTarget={1.55}
                                            modelSrc={`https://models.readyplayer.me/${avatar}.glb`}
                                            style={{borderRadius:"10px"}}
                                            onError={(e) => console.error("Avatar failed to load", e)}
                                        >
                                        <Sparkles
                                            color="white"
                                            count={60}
                                            opacity={0.9}
                                            position={[0, 3, 0]}
                                            scale={5}
                                            size={0.8}
                                            speed={0.35}
                                            />
                                    </Avatar>
                                    
                                </div>
                                <div className='col-md-6 px-0'>
                                    <ChatBot settings={settings} style={style} flow={flow}/>      
                                </div>
                        </div>
                    </div>

                ):(
                    <>
                        <div className='d-flex justify-content-center pb-5'>
                            <div style={{position:"relative"}}>
                                {showOverlay && <div className="settings-button-overlay"></div>} 
                                {showOverlayBackground && 
                                    <div className='background-prompt-overlay d-flex flex-column'>
                                            <div className='text-center'>
                                                    {loadingImg && (
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <div class="spinner-grow text-light mx-1" role="status">
                                                               <span class="visually-hidden">Loading...</span>
                                                            </div>
                                                            <div class="spinner-grow text-light mx-1" role="status">
                                                               <span class="visually-hidden">Loading...</span>
                                                            </div>
                                                            <div class="spinner-grow text-light mx-1" role="status">
                                                               <span class="visually-hidden">Loading...</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <img src={avatarUrl} width="300px" alt="Avatar" style={{ display: loadingImg ? 'none' : '' }} onLoad={() => setLoadingImg(false)} on/>
                                            </div>
                                            <p className="text-center avenir-heavy pt-2" style={{fontSize:"1.2em",paddingBottom:"40px"}}>{t('chatbot.overlayText')}</p>
                                            <div style={{ position: 'absolute', bottom:"20px", right: isArabic ? 'auto' : 0, left: isArabic ? 0 : 'auto'}}>
                                                    <button className='btn create-avatar-button avenir-heavy' onClick={handleChat}>{t('chatbot.NEXT')}</button>
                                            </div>
                                    </div>
                                }
                                <AvatarCreator
                                    subdomain="wellbe" 
                                    config={avatarConfig} 
                                    className="avatar-container"
                                    onAvatarExported={ handleExportedAvatar }
                                />
                            </div>
                        </div>
                    </>
                )}

            <Footer/>
        </div>

    );

};

export default AvatarChatbot;